import * as recruitmentTypes from "../../types/admin/recruitmentTypes";
import axios from "axios";
import { message } from "antd";

//UPDATE_RECRUITMENT
export const updateCompanyAction =
  (formDated) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_RECRUITMENT_COMPANY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const formData = new FormData();
      if (formDated.companyLogo && formDated.companyLogo.length > 0) {
        formData.append("logo", formDated.companyLogo[0].originFileObj);
      }
      if (formDated.companyName) {
        formData.append("companyName", formDated.companyName);
      }
      if (formDated.about) {
        formData.append("about", formDated.about);
      }
      if (formDated.companyWebsite) {
        formData.append("website", formDated.companyWebsite);
      }
      if (formDated.numberOfEmployees) {
        formData.append("numberOfEmployees", formDated.numberOfEmployees);
      }
      if (formDated.offices) {
        formData.append("officeArr", JSON.stringify(formDated.offices));
      }
      if (formDated.pocArr) {
        formData.append("pocArr", JSON.stringify(formDated.pocArr));
      }
      if (formDated.industry) {
        formData.append("industry", formDated.industry);
      }
      if (formDated.companyId) {
        formData.append("companyId", formDated.companyId);
      }

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/company/update`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_RECRUITMENT_COMPANY_SUCCESS,
        payload: data?.data,
      });
      return data?.data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_RECRUITMENT_COMPANY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//DUPLICATE_JOB_AD
export const duplicateJobAdAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.DUPLICATE_JOB_AD_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/details/duplicate`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.DUPLICATE_JOB_AD_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.DUPLICATE_JOB_AD_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//UPDATE_JOB_AD_DETAILS
export const updateJobAdDetailsAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_DETAILS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/details/update`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_DETAILS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_DETAILS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//UPDATE_JOB_AD_APPLICATION
export const updateJobAdApplicationAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_APPLICATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/applicationForm/update`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_APPLICATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_APPLICATION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//UPDATE_JOB_AD_WORKFLOW
export const updateJobAdWorkflowAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_WORKFLOW_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/workflow/update`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_WORKFLOW_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_WORKFLOW_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//UPDATE_JOB_AD_STATUS
export const updateJobAdStatusAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_STATUS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/status/update`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_STATUS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_STATUS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// DELETE_JOB_AD
export const deleteJobAdAction = (jobAdId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: recruitmentTypes.DELETE_JOB_AD_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/delete/${jobAdId}`,
      config
    );
    // console.log(data);
    dispatch({
      type: recruitmentTypes.DELETE_JOB_AD_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: recruitmentTypes.DELETE_JOB_AD_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//GET_JOB_AD
export const getJobAdAction = (jobAdId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: recruitmentTypes.GET_JOB_AD_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/get/${jobAdId}`,
      config
    );
    // console.log(data);
    dispatch({
      type: recruitmentTypes.GET_JOB_AD_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: recruitmentTypes.GET_JOB_AD_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//GET_ALL_JOB_AD
export const getAllJobAdAction = (jobAdId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: recruitmentTypes.GET_ALL_JOB_AD_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/all/get`,
      config
    );

    dispatch({
      type: recruitmentTypes.GET_ALL_JOB_AD_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: recruitmentTypes.GET_ALL_JOB_AD_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//GET_PAGINATED_JOB_AD
export const getPaginatedJobAdAction = (body) => async (dispatch, getState) => {
  try {
    dispatch({
      type: recruitmentTypes.GET_PAGINATED_JOB_AD_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    let userType = "";
    if (sharedUserInfo?.payload) {
      userType = sharedUserInfo?.payload?.type;
    } else {
      userType = sharedUserInfo?.type;
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}${
        userType !== "admin" && userType !== "user" && userType !== "guest"
          ? `/api/admin/${companyId}/recruitment/jobad/manager/paginated/all`
          : `/api/admin/${companyId}/recruitment/jobad/admin/paginated/all`
      }`,
      body,
      config
    );

    dispatch({
      type: recruitmentTypes.GET_PAGINATED_JOB_AD_SUCCESS,
      payload: data?.data,
    });
    return data?.data;
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: recruitmentTypes.GET_PAGINATED_JOB_AD_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//GET_PAGINATED_JOB_FILTERS
export const getPaginatedJobFiltersAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_PAGINATED_JOB_FILTERS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/values`,
        config
      );

      dispatch({
        type: recruitmentTypes.GET_PAGINATED_JOB_FILTERS_SUCCESS,
        payload: data?.data,
      });
      return data?.data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_PAGINATED_JOB_FILTERS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_ALL_JOB_AD
export const getAllJobAdDetailsAction =
  (jobAdId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_ALL_JOB_AD_DETAILS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/details/all/get`,
        config
      );
      // console.log({ data });
      dispatch({
        type: recruitmentTypes.GET_ALL_JOB_AD_DETAILS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_ALL_JOB_AD_DETAILS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_JOB_AD_DETAILS
export const getJobAdDetailsAction =
  (jobAdId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_JOB_AD_DETAILS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/company/jobad/details/get/${jobAdId}`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_JOB_AD_DETAILS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_JOB_AD_DETAILS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_JOB_AD_APPLICATION
export const getJobAdApplicationAction =
  (jobAdId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_JOB_AD_APPLICATION_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/application-form/get/${jobAdId}`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_JOB_AD_APPLICATION_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_JOB_AD_APPLICATION_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_JOB_AD_WORKFLOW
export const getJobAdWorkflowAction =
  (jobAdId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_JOB_AD_WORKFLOW_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/workflow/get/${jobAdId}`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_JOB_AD_WORKFLOW_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_JOB_AD_WORKFLOW_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_ALL_COMPANIES
export const getAllCompaniesAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: recruitmentTypes.GET_ALL_COMPANIES_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/company/get`,
      config
    );
    dispatch({
      type: recruitmentTypes.GET_ALL_COMPANIES_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: recruitmentTypes.GET_ALL_COMPANIES_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//GET_COMPANY
export const getCompanyAction =
  (getCompanyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_COMPANY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/company/get/${getCompanyId}`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_COMPANY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_COMPANY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_COMPANY
export const getCompanyPublicAction =
  (getCompanyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_COMPANY_PUBLIC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/recruitment/company/jobad/get/${getCompanyId}`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_COMPANY_PUBLIC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_COMPANY_PUBLIC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_COMPANY
export const getJobPublicAction =
  (getCompanyIdentifier, jobId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_JOB_PUBLIC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/recruitment/company/jobad/details/get/${getCompanyIdentifier}/${jobId}`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_JOB_PUBLIC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_JOB_PUBLIC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//DELETE_COMPANY
export const deleteCompanyAction =
  (deleteCompanyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.DELETE_COMPANY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/company/delete/${deleteCompanyId}`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.DELETE_COMPANY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.DELETE_COMPANY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//CANDIDATE_APPLY
export const candidateApplyAction =
  (formDated) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.CANDIDATE_APPLY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const formData = new FormData();
      formData.append("firstName", formDated.firstName);
      formData.append("lastName", formDated.lastName);
      formData.append("jobAdPostId", formDated.jobAdPostId);
      formData.append("email", formDated.email);
      if (formDated.linkedin) {
        formData.append("linkedin", formDated.linkedin);
      }
      if (formDated.maxProfile) {
        formData.append("maxProfile", formDated.maxProfile);
      }
      if (formDated.coverLetterContent) {
        formData.append("coverLetterContent", formDated.coverLetterContent);
      }
      if (formDated.attachment) {
        formData.append("cv", formDated.attachment);
      }
      // if (formDated.attachment) {
      //   formData.append("coverLetter", formDated.attachment);
      // }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/recruitment/candidate/create`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.CANDIDATE_APPLY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.CANDIDATE_APPLY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//ADD_CANDIDATE
export const addCandidateAction = (formDated) => async (dispatch, getState) => {
  try {
    dispatch({
      type: recruitmentTypes.ADD_CANDIDATE_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    const formData = new FormData();
    formData.append("firstName", formDated.firstName);
    formData.append("lastName", formDated.lastName);

    if (formDated.email) {
      formData.append("email", formDated.email);
    }
    if (formDated.phone) {
      formData.append("phone", formDated.phone);
    }
    if (formDated.nationality) {
      formData.append("nationality", formDated.nationality);
    }
    if (formDated.currentCompany) {
      formData.append("currentCompany", formDated.currentCompany);
    }
    if (formDated.jobTitle) {
      formData.append("jobTitle", formDated.jobTitle);
    }
    if (formDated.industry) {
      formData.append("industry", formDated.industry);
    }
    if (formDated.maritalStatus) {
      formData.append("maritalStatus", formDated.maritalStatus);
    }
    if (formDated.dateOfBirth) {
      formData.append("dateOfBirth", formDated.dateOfBirth);
    }
    if (formDated.current) {
      formData.append("current", formDated.current);
    }
    if (formDated.expected) {
      formData.append("expected", formDated.expected);
    }
    if (formDated.currency) {
      formData.append("currency", formDated.currency);
    }

    if (formDated.jobAdPostId) {
      formData.append("jobAdPostId", formDated.jobAdPostId);
    }
    if (formDated.linkedin) {
      formData.append("linkedin", formDated.linkedin);
    }
    if (formDated.talentPool) {
      formData.append("talentPool", formDated.talentPool);
    }
    if (formDated.maxProfile) {
      formData.append("maxProfile", formDated.maxProfile);
    }
    if (formDated.coverLetterContent) {
      formData.append("coverLetterContent", formDated.coverLetterContent);
    }
    if (formDated.attachment) {
      formData.append("cv", formDated.attachment);
    }
    // if (formDated.attachment) {
    //   formData.append("coverLetter", formDated.attachment);
    // }
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/candidate/new/add`,
      formData,
      config
    );
    // console.log(data);
    dispatch({
      type: recruitmentTypes.ADD_CANDIDATE_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: recruitmentTypes.ADD_CANDIDATE_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//CANDIDATE_APPLY
export const candidateScreenAnswerAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.CANDIDATE_APPLY_SCREENING_ANSWER_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/recruitment/candidate/screening/question/create`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.CANDIDATE_APPLY_SCREENING_ANSWER_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.CANDIDATE_APPLY_SCREENING_ANSWER_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_ALL_CANDIDATES
export const getAllCandidatesAction =
  (jobAdId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_ALL_CANDIDATES_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/candidate/get`,
        config
      );

      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_ALL_CANDIDATES_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_ALL_CANDIDATES_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_CANDIDATE
export const getCandidateAction =
  (candidateId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_CANDIDATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/candidate/get/${candidateId}`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_CANDIDATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_CANDIDATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//UPDATE_JOB_AD_DETAILS
export const updateCandidateStatusAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_CANDIDATE_STATUS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/candidate/update/status`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_CANDIDATE_STATUS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_CANDIDATE_STATUS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// UPDATE_CANDIDATE_NOTES
export const updateCandidateNotesAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_CANDIDATE_NOTES_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/candidate/update/note`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_CANDIDATE_NOTES_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_CANDIDATE_NOTES_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// UPDATE_CANDIDATE_TALENTPOOL
export const updateCandidateTalentPoolAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_CANDIDATE_TALENTPOOL_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/candidate/update/talentpool`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_CANDIDATE_TALENTPOOL_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_CANDIDATE_TALENTPOOL_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// UPDATE_BULK_CANDIDATE_TALENTPOOL
export const updateBulkCandidateTalentPoolAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_BULK_CANDIDATE_TALENTPOOL_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/candidate/update/note`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_BULK_CANDIDATE_TALENTPOOL_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_BULK_CANDIDATE_TALENTPOOL_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// ARCHIVE_BULK_CANDIDATE
export const archiveBulkCandidateAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.ARCHIVE_BULK_CANDIDATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/candidate/update/note`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.ARCHIVE_BULK_CANDIDATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.ARCHIVE_BULK_CANDIDATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// UPDATE_RECRUITER_ASSESSMENT
export const updaterRecruiterAssessmentAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_RECRUITER_ASSESSMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/recruiter/assessment/update`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_RECRUITER_ASSESSMENT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_RECRUITER_ASSESSMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// UPDATE_RECRUITER_ASSESSMENT
export const updaterCandidateRecruiterAssessmentAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/candidate/asseessment`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// UPDATE_RECRUITER_ASSESSMENT
export const getCandidateFromTalentPoolAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_CANDIDATE_FROM_TALENTPOOL_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/talentpool/get`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_CANDIDATE_FROM_TALENTPOOL_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_CANDIDATE_FROM_TALENTPOOL_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const assignJobToTalentPoolAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.ASSIGN_JOB_TO_TALENTPOOL_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/candidate/from/talentpool/add`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.ASSIGN_JOB_TO_TALENTPOOL_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.ASSIGN_JOB_TO_TALENTPOOL_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// UPLOAD_CANDIDATE_CVS
export const UploadCandidateFilesAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPLOAD_CANDIDATE_CVS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/candidate/cv/bulk/upload/`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPLOAD_CANDIDATE_CVS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPLOAD_CANDIDATE_CVS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// UPLOAD_CANDIDATE_CVS_PARSING
export const UploadCandidateFilesParseAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPLOAD_CANDIDATE_CVS_PARSING_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/candidate/bulk/upload/cv/parse`,
        formData,
        config
      );
      // const data = {};
      // data.logs = [
      //   { fileKey: "ASDASDASD", error: "file too big" },
      //   { fileKey: "ASDASDASD", error: "file too big" },
      // ];

      dispatch({
        type: recruitmentTypes.UPLOAD_CANDIDATE_CVS_PARSING_SUCCESS,
        payload: { data: data?.data, logs: data?.logs },
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPLOAD_CANDIDATE_CVS_PARSING_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_ALL_RECRUIT_COMPANIES
export const getAllRecruitCompaniesAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_ALL_RECRUIT_COMPANIES_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/company/get/list`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_ALL_RECRUIT_COMPANIES_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_ALL_RECRUIT_COMPANIES_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_ALL_STATUSES_TEMPLATES
export const getAllStatusesTemplatesAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_ALL_STATUSES_TEMPLATES_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/job-stage-templates`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_ALL_STATUSES_TEMPLATES_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_ALL_STATUSES_TEMPLATES_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//CREATE_STATUSES_TEMPLATE
export const createStatusesTemplatesAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.CREATE_STATUSES_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/job-stage-template/add`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.CREATE_STATUSES_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.CREATE_STATUSES_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//UPDATE_STATUSES_TEMPLATE
export const updateStatusesTemplatesAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_STATUSES_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log({ body });
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/job-stage-template/${body?._id}/update`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_STATUSES_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_STATUSES_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//DELETE_STATUSES_TEMPLATE
export const deleteStatusesTemplatesAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.DELETE_STATUSES_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      // console.log(`token:${sharedUserInfo?.payload?.token}`);

      const config = {
        headers: {
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
        data: formData,
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log({ config });
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/job-stage-template/delete`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.DELETE_STATUSES_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.DELETE_STATUSES_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

// UPDATE_TEMPLATE_ID_TO_JOB_AD_POST
export const updateTemplateIdToJobAdAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/recruitment/jobad/stage-temp/update`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_ALL_STATUSES_TEMPLATES
export const getAllEmailTemplatesAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: recruitmentTypes.GET_ALL_EMAIL_TEMPLATE_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/email-temp`,
      config
    );
    // console.log(data);
    dispatch({
      type: recruitmentTypes.GET_ALL_EMAIL_TEMPLATE_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: recruitmentTypes.GET_ALL_EMAIL_TEMPLATE_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//CREATE_EMAIL_TEMPLATE
export const createEmailTemplatesAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.CREATE_EMAIL_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/email-temp/add`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.CREATE_EMAIL_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.CREATE_EMAIL_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//UPDATE_EMAIL_TEMPLATE
export const updateEmailTemplatesAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_EMAIL_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log({ body });
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/email-temp/${body?._id}/update`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_EMAIL_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_EMAIL_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//DELETE_EMAIL_TEMPLATE
export const deleteEmailTemplatesAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.DELETE_EMAIL_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      // console.log(`token:${sharedUserInfo?.payload?.token}`);

      const config = {
        headers: {
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
        data: formData,
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/email-temp/del`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.DELETE_EMAIL_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.DELETE_EMAIL_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
export const addJobPostIdAction = (formData) => async (dispatch) => {
  try {
    dispatch({
      type: recruitmentTypes.ADD_JOB_POST_ID_SUCCESS,
      payload: formData,
    });
    // dispatch({
    //   type: recruitmentTypes.UPDATE_JOB_AD_DETAILS_SUCCESS,
    //   payload: null,
    // });
  } catch (error) {
    dispatch({
      type: recruitmentTypes.ADD_JOB_POST_ID_SUCCESS,
      payload: "",
    });
  }
};

//Testing Phase
//GET_ALL_ON_BOARDING_TEMPLATES
export const getAllOnboardingTemplatesAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_ALL_ON_BOARDING_TEMPLATES_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/on-boarding-temp/get/all`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.GET_ALL_ON_BOARDING_TEMPLATES_SUCCESS,
        payload: data?.template,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_ALL_ON_BOARDING_TEMPLATES_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//GET_ON_BOARDING_TEMPLATES
export const getOnboardingTemplatesAction =
  (id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_ON_BOARDING_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log({ id });
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/on-boarding-temp/${id}`,

        config
      );
      // console.log({ data });
      dispatch({
        type: recruitmentTypes.GET_ON_BOARDING_TEMPLATE_SUCCESS,
        payload: data?.template,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_ON_BOARDING_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//CREATE_ON_BOARDING_TASKS
export const createOnboardingTasksAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.CREATE_ON_BOARDING_TASKS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/on-boarding-temp/tasks/add`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.CREATE_ON_BOARDING_TASKS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.CREATE_ON_BOARDING_TASKS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//ASSIGN_ON_BOARDING_TASKS
export const assignOnboardingTasksAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.ASSIGN_ON_BOARDING_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/on-boarding-temp/employee/assign`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.ASSIGN_ON_BOARDING_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.ASSIGN_ON_BOARDING_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//CREATE_ON_BOARDING_TEMPLATE
export const createOnboardingTemplatesAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.CREATE_ON_BOARDING_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/on-boarding-temp/tasks/add`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.CREATE_ON_BOARDING_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.CREATE_ON_BOARDING_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//UPDATE_ON_BOARDING_TEMPLATE
export const updateOnboardingTemplatesAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_ON_BOARDING_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log({ body });
      // console.log({ companyId });
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/on-boarding-temp/add`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_ON_BOARDING_TEMPLATE_SUCCESS,
        payload: data?.template,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_ON_BOARDING_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//DELETE_ON_BOARDING_TEMPLATE
export const deleteOnboardingTemplatesAction =
  (templateId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.DELETE_ON_BOARDING_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/on-boarding-temp/${templateId}/delete`,
        config
      );

      dispatch({
        type: recruitmentTypes.DELETE_ON_BOARDING_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }

      dispatch({
        type: recruitmentTypes.DELETE_ON_BOARDING_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const getDataKanbanAction = (formData) => async (dispatch) => {
  try {
    dispatch({
      type: recruitmentTypes.GET_KANBAN_DATA_SUCCESS,
      payload: formData,
    });
    // dispatch({
    //   type: recruitmentTypes.UPDATE_JOB_AD_DETAILS_SUCCESS,
    //   payload: null,
    // });
  } catch (error) {
    dispatch({
      type: recruitmentTypes.GET_KANBAN_DATA_SUCCESS,
      payload: "",
    });
  }
};

//CREATE_MANDATORY_DOCUMENT_TEMPLATE
export const createMultipleDocumentTemplateAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.CREATE_MANDATORY_DOCUMENT_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/document-temp/create-multi`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.CREATE_MANDATORY_DOCUMENT_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.CREATE_MANDATORY_DOCUMENT_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//CREATE_DOCUMENT_TEMPLATE
export const createDocumentTemplateAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.CREATE_DOCUMENT_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/document-temp/create`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.CREATE_DOCUMENT_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.CREATE_DOCUMENT_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//UPDATE_DOCUMENT_STATUS
export const updateDocumentStatusAction =
  (body, _id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_DOCUMENT_STATUS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log({ body });
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/document-temp/${_id}/change/status`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_DOCUMENT_STATUS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_DOCUMENT_STATUS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//UPDATE_DOCUMENT_TYPE
export const updateDocumentTypeAction =
  (body, _id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_DOCUMENT_TYPE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log({ body });
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/document-temp/${_id}/change/mandatory`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_DOCUMENT_TYPE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_DOCUMENT_TYPE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//UPDATE_DOCUMENT_TEMPLATE
export const updateDocumentTemplateAction =
  (body) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.UPDATE_DOCUMENT_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log({ body });
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/document-temp/${body?._id}/update`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.UPDATE_DOCUMENT_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.UPDATE_DOCUMENT_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_ALL_DOCUMENT_TEMPLATE
export const getAllDocumentTemplateAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_ALL_DOCUMENT_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/document-temp/get-all`,
        config
      );
      // console.log({ "data.data": data.data });
      dispatch({
        type: recruitmentTypes.GET_ALL_DOCUMENT_TEMPLATE_SUCCESS,
        payload: data?.data?.temps || [],
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.GET_ALL_DOCUMENT_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const deleteDocumentTemplateAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.DELETE_DOCUMENT_TEMPLATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      // console.log(`token:${sharedUserInfo?.payload?.token}`);

      const config = {
        headers: {
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
        data: formData,
      };
      const body = formData;

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log({ config });
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/document-temp/${formData}/delete`,
        config
      );
      // console.log(data);
      dispatch({
        type: recruitmentTypes.DELETE_DOCUMENT_TEMPLATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: recruitmentTypes.DELETE_DOCUMENT_TEMPLATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const getEmployeePdfAction =
  (userId, userName) => async (dispatch, getState) => {
    try {
      dispatch({
        type: recruitmentTypes.GET_EMPLOYEE_PDF_REQUEST,
      });

      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
        responseType: "blob", // Set the response type to blob
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employee-resume/${userId}/download`,
        config
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${userName}.pdf`);
      document.body.appendChild(link);
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      dispatch({
        type: recruitmentTypes.GET_EMPLOYEE_PDF_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.log({ error });
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: recruitmentTypes.GET_EMPLOYEE_PDF_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
